import script from "./TutorialMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TutorialMenu.vue?vue&type=script&setup=true&lang=ts"

import "./TutorialMenu.vue?vue&type=style&index=0&id=2c61a348&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c61a348"]])

export default __exports__